import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography/Typography";
import {Translate} from "../../../../config/Translate";
import {imgSize} from "../../../../config/values";
class SingleFileChooser extends React.Component {
    classes = this.props.classes;


    render(){
        let{width,height,long} = this.props;

        return(
            <Typography style={{color:"#c88600",marginTop:7,marginBottom:7,textAlign:long ? "right" : "center"}}>
                <span>{Translate.imageProperWidthHeight}</span>
                <span> {width}x{height} {Translate.pixel} </span> /
                <span> {Translate.imageProperWeight} </span>
                <span> {imgSize} </span>
            </Typography>
        )

    }
}
export default withStyles(Styles)(SingleFileChooser);